

export default {
    computed: {
        routeName() {
            const {name} = this.$route
            return this.capitalizeFirstLetter(name)
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        }
    },

    data() {
        return {
            dotColors: ['#FF5252', '#4CAF50', '#448AFF'],
        }
    },

    beforeMount() {

    },
}


// WEBPACK FOOTER //
// ./src/components/Layout/MyLoader.js